import React from "react";
import styles from "./PromoPopup.module.scss";
import { Link } from "react-router-dom";
import LoadingComponent from "../../../LodingComponent/LoadingComponent";

// Bu interfeysi export edirik ki, MainRoot-da da eyni tipi istifadə edək
export interface CampaignDisplay {
  id: number;
  text: string;
  cover_image: string;
}

interface PromoPopupProps {
  isOpen: boolean;
  onClose: () => void;
  campaign: CampaignDisplay | null;
  isLoading?: boolean;
}

const PromoPopup: React.FC<PromoPopupProps> = ({
  isOpen,
  onClose,
  campaign,
  isLoading = false,
}) => {
  if (!isOpen) return null;

  // Şəklin mənbəyi
  const imageSrc = campaign?.cover_image || null;

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        {/* Şəkil Hissəsi */}
        <div className={styles.imageWrapper}>
          {isLoading ? (
            <LoadingComponent
              height="100%"
              width="100%"
              style={{ minHeight: "240px" }}
            />
          ) : imageSrc ? (
            <img
              src={imageSrc}
              alt="Kampaniya"
              className={styles.image}
              loading="eager"
            />
          ) : (
            <div className={styles.noImage}>Şəkil yoxdur</div>
          )}

          {!isLoading && (
            <button className={styles.closeBtn} onClick={onClose}>
              X
            </button>
          )}
        </div>

        {/* Məzmun Hissəsi */}
        <div className={styles.content}>
          {isLoading ? (
            <>
              <LoadingComponent
                height={24}
                width="70%"
                style={{ marginBottom: 12 }}
              />
              <LoadingComponent
                height={16}
                width="100%"
                count={2}
                style={{ marginBottom: 20 }}
              />
              <LoadingComponent height={40} width={120} borderRadius={999} />
            </>
          ) : campaign ? (
            <>
              {/* API-dən gələn tək 'text' sahəsi */}
              <p
                className={styles.subtitle}
                dangerouslySetInnerHTML={{ __html: campaign.text }}
              ></p>
              {/* Əgər text sadə stringdirsə: <p className={styles.subtitle}>{campaign.text}</p> */}

              <Link
                to="/" // Əgər xüsusi link yoxdursa ana səhifəyə və ya sadəcə bağlamaq üçün '#'
                onClick={onClose}
                role="button"
              >
                <button className={styles.ctaButton}>Daha ətraflı</button>
              </Link>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PromoPopup;
